module.exports = __webpack_public_path__ + "static/webscale-0092fde1d080e6784490cb4c05267026.svg";